import { useEffect, useRef, useState } from 'react';

const useDebounce = (callback: () => void, delay: number) => {
  const latestCallback = useRef<typeof callback>();
  const [lastCalledAt, setLastCalledAt] = useState<number | null>(null);

  useEffect(() => {
    latestCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (lastCalledAt) {
      const fire = () => {
        setLastCalledAt(null);
        latestCallback.current!();
      };
      const fireAt = lastCalledAt + delay;
      const fireIn = Math.max(fireAt - Date.now(), 0);
      const id = setTimeout(fire, fireIn);

      return () => clearTimeout(id);
    }
  }, [lastCalledAt, delay]);

  return () => setLastCalledAt(Date.now());
};

export default useDebounce;
